import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

interface ItemType {
    img: string;
    name: string;
    text: string;
    memo?: string;
}
const M: React.FC = () => {
    const { t } = useLang('d3u');
    const [gap, setGap] = useState(24);
    const items: ItemType[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1760931526521/13_1.jpg',
            name: t('M_item1_name'),
            text: t('M_item1_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1760931526739/13_2.jpg',
            name: t('M_item2_name'),
            text: t('M_item2_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1760931537757/13_3.jpg',
            name: t('M_item3_name'),
            text: t('M_item3_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1760931526922/13_4.jpg',
            name: t('M_item4_name'),
            text: t('M_item4_text'),
            memo: t('M_item4_memo'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1440 ? 24 : window.innerWidth > 1024 ? 20 : 12);
        }
    }, []);

    return (
        <section className={`${css.section} D3U-M GtmModuleData-section`} id="D3U-M" data-section-id={'D3U-M'} data-section-id2={t('M_title')}>
            <div className="info">
                <p className="label">{t('M_label')}</p>
                <p className="title">{t('M_title')}</p>
            </div>
            <Swiper className="items" slidesPerView={'auto'} spaceBetween={gap} modules={[Navigation]} navigation={true}>
                {items.map((item: ItemType, index: number) => (
                    <SwiperSlide className="item" key={index}>
                        <div className="img">
                            <EcoImg pc={item.img} />
                        </div>
                        <div className="msg">
                            <p className="name">{item.name}</p>
                            <p className="text">{item.text}</p>
                            {item.memo && <p className="memo">{item.memo}</p>}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default M;
